// extracted by mini-css-extract-plugin
module.exports = {"assetPreview":"CampaignAssetsModal-module__assetPreview___1E8Wc","empty":"CampaignAssetsModal-module__empty___VFx59"};